import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import { EmailSpamListItemDto } from '@sr/dto';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { emailParserApi } from 'email-parser/email-parser.api';
import { usePagingParams } from 'shared/hooks/paging-params';
import { GridLayout } from 'shared/ui/grid-layout';
import { LinkToLead } from 'shared/ui/links/link-to-lead';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useSnack } from 'shared/ui/snack';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { EmailSpamFilter } from 'features/email-parser/email-spam-filter';

const columns = ['Email', 'Дата добавления', 'Лид', ''];

const EmailSpamList = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const { data, isLoading, error } = emailParserApi.useGetSpamQuery({ paging, email: searchParams.get('email') ?? undefined });
  const [deleteSpam, { isLoading: isDeleting }] = emailParserApi.useDeleteSpamMutation();
  const showConfirm = useConfirmDialog();
  const { showSuccess, showError } = useSnack();
  const [deletingId, setDeletingId] = useState<number | null>(null);

  const handleDelete = async (item: EmailSpamListItemDto) => {
    await showConfirm({ content: `Удалить адрес «${item.email}» из списка спама?` });
    setDeletingId(item.id);
    try {
      await deleteSpam(item.id).unwrap();
      showSuccess('Адрес удалён из списка спама');
    } catch (e) {
      showError(`Ошибка удаления: ${extractNestJsErrorMessage(e)}`);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <Box mt={2}>
      <EmailSpamFilter />
      <GridLayout<EmailSpamListItemDto>
        columns={columns}
        items={data?.items ?? []}
        isLoading={isLoading}
        error={error ? extractNestJsErrorMessage(error) : undefined}
        pagingData={paging}
        onChangePaging={setPaging}
        totalItemsCount={data?.totalItemsCount ?? 0}
        noItemsText="Список спама пуст"
        itemRender={(item) => (
          <TableRow key={item.id}>
            <TableCell>{item.email}</TableCell>
            <TableCell>{new Date(item.createdAt).toLocaleString('ru-RU')}</TableCell>
            <TableCell>{item.lead ? <LinkToLead lead={item.lead} /> : '—'}</TableCell>
            <TableCell align="right">
              <Tooltip title="Удалить из спама">
                <span>
                  <IconButton size="small" onClick={() => handleDelete(item)} disabled={isDeleting || deletingId === item.id}>
                    <DeleteOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </TableCell>
          </TableRow>
        )}
      />
    </Box>
  );
};

export default EmailSpamList;
